export const THIRD_PARTY_VRM_PATTERN =
    /^(?:[A-Z]{2}[0-9]{2}[A-Z]{3}|[A-Z][0-9]{1,3}[A-Z]{3}|[A-Z]{3}[0-9]{1,3}[A-Z]|[A-Z]{1,3}[0-9]{1,4}|[0-9]{1,4}[A-Z]{1,3})$/;

export const normaliseThirdPartyVrm = (value: string | undefined): string | undefined => {
    if (value === undefined || value.trim() === '') return undefined;

    const vrm = value.replace(/\s+/g, '').toUpperCase();

    return THIRD_PARTY_VRM_PATTERN.test(vrm) ? vrm : undefined;
};
